import React, { Fragment } from "react";
import { ScrollToTop } from "../../views/common/ScrollToTop/ScrollToTop";
import { Container } from "../../views/Layout";

export default (props) => {

    const iframeStyle = {
        width: "100%"
        , height: "77vh"
        , border: "0px"
    }

    return (
      <Fragment>
        <ScrollToTop />
        <Container
          Title="결제"
          dark={"dark"}
          goToUrl={
            decodeURIComponent(props.match.params.backUrl)
              ? decodeURIComponent(props.match.params.backUrl)
              : "/proof/storage/3/1/1"
          }
        >
          <div className="contents">
            <iframe style={iframeStyle} src={decodeURIComponent(props.match.params.moveUrl)} />
          </div>
        </Container>
      </Fragment>
    );
}